export const ModalStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 480,
  bgcolor: "background.paper",
  border: "1px solid #888",
  boxShadow: 24,
  borderRadius: "6px",
  p: 4,
};
